var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.orderDetail)?_c('Detail',{attrs:{"order-detail":_vm.orderDetail,"order-type":10},on:{"cancel":_vm.confirmCancel,"pay":_vm.confirmPay}}):_vm._e(),_c('toolbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }